// extracted by mini-css-extract-plugin
module.exports = {"barra":"NomeBara_barra__TteqC","nome":"NomeBara_nome__1tGpY","bimestre":"NomeBara_bimestre__1aaWH","boletim":"NomeBara_boletim__2yiV9","oculto":"NomeBara_oculto__9-ziK"};